const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Если бы я не был таким платиновым, то был бы синим. Не от печали или отчаяния. Совсем наоборот. Я был бы рад быть синим драконом… если бы не был платиновым`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
